export default __webpack_public_path__ + "static/media/Bhumika Batra.2a6919f7.jpg";